<template>
    <v-dialog scrollable :width="780" content-class="rounded-lg" :value="true" persistent>
        <v-card class="dialog-card">
            <slot name="header">
                <icon-button style="position: absolute; top: 16px; right: 16px" @click="$emit('close')">
                    mdi-close
                </icon-button>
                <v-row no-gutters class="flex-nowrap n2 py-5">
                    <v-col class="shrink ml-5">
                        <v-row no-gutters style="border-radius: 50%; height:123px; width:123px" class="white" align="center" justify="center">
                            <v-col class="shrink"><v-img :max-height="74" contain :src="require('@/assets/uku-logo-colored.svg')" /></v-col>
                        </v-row>
                    </v-col>
                    <v-col class="mt-4 col-6">
                        <v-row no-gutters class="mb-2 white py-4 px-6" style="border-radius: 24px; border: 1px dashed black !important; margin-left:-10px">
                            <v-col class="title" style="line-height: 28px">
                                <slot name="header-bubble" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="body-2">
                            <slot name="header-info" />
                        </v-row>
                    </v-col>
                </v-row>
            </slot>
            <v-card-text v-if="$slots.default" class="py-8">
                <slot />
            </v-card-text>
            <v-card-actions v-if="$slots.footer" class="pl-12" :class="footerColor">
                <slot name="footer" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "Dialog",
    props: {
        footerColor: {
            type: String,
            default: "n2"
        }
    }
};
</script>
